import { ofType } from "redux-observable";
import { of } from "rxjs";
import { delay, filter, switchMap } from "rxjs/operators";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionAddPelletsAnimations } from "../../../animation/actionPelletAnimations";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TypeActionBuildings } from "../actionBuildings";
export var epicUpgradeBuildingPellets = function (action$) {
    return action$.pipe(ofType(TypeActionBuildings.UpgradeConfirmed), filter(function (action) { return action.building.proto.id != undefined; }), delay(25), switchMap(function (action) {
        var origin = utilBuildings.getCenterPositionMinSquareGlobal(action.building);
        var pellets = [];
        var workersDifference = utilBuildings.getWorkersDifference(action.building);
        pellets.push({
            amount: workersDifference,
            icon: IdIcon.WorkersIcn,
        });
        return of(actionAddPelletsAnimations(action.building.proto.id, pellets, origin));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicUpgradeBuildingPellets.ts
// module id = 2093
// module chunks = 3